import React, { useState, useEffect, useContext } from "react";
import { Alert, Box, Grid, TextField, Typography, Button, Paper, Checkbox, FormControlLabel, Tooltip } from '@mui/material';
import { Radio, RadioGroup, FormControl, FormLabel } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Switch from '@mui/material/Switch';
import FormGroup from "@mui/material/FormGroup";
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import successIcon from '../assets/payment-success-icon.png';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { useMember } from '../context/MemberProfileContext';
import RetreatRulesComp from '../components/RetreatRulesComp'
import parse from 'html-react-parser';


import PaymentComp from '../components/PaymentComp'
import PaypalComp from '../components/PaypalComp';
import { DataContext } from '../App';
import PaypalZelle from "../components/PaypalZelle";
// added imports for pretty breakdown table
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';


export default function AllTXHighSchoolRetreat() {
    const [eventData, setEventData] = useState({
        "balaviharYear": "",
        "membershipType": {
            "name": ""
        },
        status: "",
        eventType: '',
        "notes": "first event1",
        "children": [
            {
                "memberId": "",
                "foodAllergies": "",
                "medicalAllergies": "",
                "environmentalAllergies": "",
                "prescriptionMedications": "",
                "otcMedications": "",
                "specialInstructions": "",
                "emergencyContactFullName": "",
                "emergencyContactRelationship": "",
                "emergencyContactMobile": "",
                "emergencyContactEmail": "",
                "notes": "",
            }
        ],
        "medical": {
            "pcpName": "",
            "pcpMobile": "",
            "medicalInsurance": "",
            "groupNo": "",
            "idNo": "",
            "medicalNotes": "",
            "medicalConsentSignedBy": "",
            "treatmentConsentSignedBy": ""
        },
        transaction: {
            quantities: 1,
            itemPrice: 0,
            totalAmount: "",
            donationAmount: "",
            payerId: "",
            notes: "Multiple Events",
        },
        "events": [
        ],
        feeEnabled: 0,
        parent: {
            firstName: "",
            lastName: "",
            email: "",
            mobileNumber: ""

        }
    });
    const { accessToken, signOut } = useAuth();
    const [eventTxnsHistory, setEventTxnsHistory] = useState();
    const [studentFields, setStudentFields] = useState([]);
    const [eventFields, setEventFields] = useState([]);
    //const [culturalEventTypes, setCulturalEventTypes] = useState([]);
    const [eventDescription, setEventDescription] = useState("");
    const [ticketPrice, setTicketPrice] = useState(0);
    const [eventTypeId, setEventTypeId] = useState(0);

    const [sessions, setSessions] = useState();
    const [error, setError] = useState(null);
    const [rulesAccepted, setRulesAccepted] = useState(false); // State to manage checkbox
    const API_URL = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const { memberships, setMemberships } = useMember();
    const [parivarMember, setParivarMember] = useState(false);
    const [feeEnabled, setFeeEnabled] = useState(0);
    const [parivarEnabled, setParivarEnabled] = useState(0);

    const { memberProfile, setMemberProfile } = useMember();
    const { eventTypes, setEventTypes } = useMember();
    const [inputFields, setInputFields] = useState(eventData.transaction);
    const [medicalFields, setMedicalFields] = useState(eventData.medical);
    const [fullNames, setFullNames] = useState(memberProfile.children.map((child) => child.fullName));
    const [donation, setDonation] = useState(0);
    const [totalAmount, setTotalAmount] = useState(inputFields.quantities * inputFields.itemPrice);
    const [noOfPeople, setNoOfPeople] = useState(0);
    const [displayEventType, setDisplayEventType] = useState(0);

    // Add this state near the top with other useState declarations
    const [emergencyContact, setEmergencyContact] = useState({
        emergencyContactFullName: "",
        emergencyContactRelationship: "",
        emergencyContactMobile: "",
        emergencyContactEmail: ""
    });

    useEffect(() => {

        console.log("Token exists or not :", accessToken);

        if (accessToken) {
            memberProfileFetch(); // Load membership data
            eventTxnsHistoryFetch();

        } else {
            signOut();
            navigate('/');
        }
    }, [accessToken])         // Empty dependency array ensures this runs once on mount;

    //Chinmaya Parivar Member
    const [payloadData, setPayloadData] = useState({});

    //to populate registered children


    console.log("Fullnames at the beginning:", fullNames, studentFields);
    const [email, setEmail] = useState("");
    useEffect(() => {
        setEmail(memberProfile.primary.email); // Assign email from memberProfile
    }, [])         // Empty dependency array ensures this runs once on mount
    useEffect(() => {
        eventData.parent.firstName = memberProfile.primary.firstName;
        eventData.parent.lastName = memberProfile.primary.lastName;
        eventData.parent.email = memberProfile.primary.email;
        eventData.parent.mobileNumber = memberProfile.primary.mobileNumber.replace(/[-\s]/g, ''); // Remove hyphens and spaces    
    }, [])         // Empty dependency array ensures this runs once on mount 

    useEffect(() => {
        if (eventTypes && eventTypes.length > 0) {
            // Filter the event types to find the one with the name 'AllTXHighSchoolRetreat'
            const laborEventType = (eventTypes.find((eventType) => eventType.name === 'AllTXHighSchoolRetreat'));
            setDisplayEventType(laborEventType);
            console.log("Language Event Type, fullnames:", eventTypes, displayEventType, fullNames);
            if (laborEventType) {
                console.log("Event Type found with the name 'AllTXHighSchoolRetreat':", displayEventType);
                eventData.balaviharYear = (laborEventType.eventYear); // Set the balavihar year
                eventData.eventType = (laborEventType.name); // Set the event description
                setTicketPrice(laborEventType.price); // Set the ticket price
                setEventTypeId(laborEventType.eventTypeId); // Set the event type ID

            } else {
                console.log("No event type found with the name 'AllTXHighSchoolRetreat'");
                //setCulturalEventTypes([]); // Set to an empty array if no matching record is found
            }
        }
    }, [eventTypes]);

    // Function to handle adding/removing children
    function peopleSwitchHandler(e) {
        console.log("switch handler :", e.target.checked);
        handleAddFields();
    };
    const handleAddFields = () => {
        //console.log("Handle add fileds", fullNames.length, noOfPeople, childLimit, fullNames.length - 1);
        if (noOfPeople > fullNames.length) {
            console.log("No children available to add. Please add children in the profile screen to proceed.");
            setError("No children available to add. Please add children in the profile screen to proceed or Checkout to complete the registration.");
            return;
        }

        setStudentFields([...studentFields, {
            memberType: "child", fullName: ""
        }]);
        setNoOfPeople(noOfPeople + 1);
    };
    const handleRemoveFields = (index) => {
        const values = [...studentFields];
        const eventForm = [...eventFields];
        values.splice(index, 1);
        eventForm.splice(index, 1);
        setStudentFields(values);
        setEventFields(eventForm);
        eventData.children = values;
        eventData.events = eventForm;
        setNoOfPeople(noOfPeople - 1);
    };
    const handleStudentChange = (e, index) => {
        console.log("Event data in Student handle form :", studentFields, eventFields, eventTypeId);
        let newForm = [...studentFields];
        let eventForm = [...eventFields];
        newForm[index][e.target.name] = e.target.value;
        const selectedChild = memberProfile.children.find((child) => child.fullName === e.target.value);
        if (selectedChild) { // Populate the child's details
            newForm[index].firstName = selectedChild.firstName;
            newForm[index].lastName = selectedChild.lastName;
            newForm[index].memberId = selectedChild.memberId; // Add memberId to the studentFields
            newForm[index].eventTypeId = eventTypeId; //
            if (!eventForm[index]) {
                eventForm[index] = {};
            }
            eventForm[index].eventTypeId = eventTypeId; // Update eventData with eventTypeId
            eventForm[index].memberId = selectedChild.memberId; // Update eventData with memberId
        }
        setStudentFields(newForm);
        setEventFields(eventForm);
        eventData.children = newForm;
        eventData.events = eventForm;
    }

    // Populate the full names of the available children
    const getAvailableChildren = (index) => {
        const selectedChildren = studentFields.map((student) => student.fullName);
        return fullNames.filter((name) => !selectedChildren.includes(name) || studentFields[index].fullName === name);
    }
    function handleMedicalChange(e) {
        let newForm = { ...medicalFields };
        newForm[e.target.name] = e.target.value;
        setMedicalFields(newForm);
        eventData.medical = newForm;
    }

    // Emergency Contact Information
    const handleEmergencyContactChange = (e) => {
        setEmergencyContact({ ...emergencyContact, [e.target.name]: e.target.value });
    };
    // Add this function to apply emergency contact to all children
    const applyEmergencyContactToAllChildren = () => {

        const updatedStudentFields = studentFields.map(student => ({
            ...student,
            emergencyContactFullName: emergencyContact.emergencyContactFullName,
            emergencyContactRelationship: emergencyContact.emergencyContactRelationship,
            emergencyContactMobile: emergencyContact.emergencyContactMobile,
            emergencyContactEmail: emergencyContact.emergencyContactEmail
        }));

        setStudentFields(updatedStudentFields);
        eventData.children = updatedStudentFields;
        setError(null);
    };

    const total = () => {
        inputFields.donationAmount = donation;
        inputFields.totalAmount = totalAmount;
        eventData.transaction = inputFields;
    }
    total();

    useEffect(() => {

        eventData.transaction.itemPrice = ticketPrice;
        eventData.transaction.quantities = noOfPeople;

        if (feeEnabled) {
            setTotalAmount(((parseInt(noOfPeople) * parseInt(ticketPrice) + parseInt(donation)) * 1.03).toFixed(2));
        } else {
            setTotalAmount((parseInt(noOfPeople) * parseInt(ticketPrice) + parseInt(donation)) * 1.00);
        }

        eventData.transaction.totalAmount = totalAmount;
        console.log("Run 1 calculate price :", (eventData.events), ticketPrice, totalAmount);

    }, [noOfPeople, donation, feeEnabled, parivarEnabled, ticketPrice, eventData.events, memberships.totalAmountPaid, memberships.status, parivarMember]);



    const eventTxnsHistoryFetch = async () => {
        let response, data;
        try {
            const response = await fetch(`${API_URL}/gquery`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-cmdfw-jwt-token': `${accessToken}`,
                },
                body: JSON.stringify({
                    query: `
                            query {
                              eventsHistory {
                                  events {
                                      memEventsId
                                      status
                                      startDate
                                      endDate
                                      memberEntity {
                                          memberId
                                          memberType
                                          fullName
                                      }
                                      eventTypesEntity {
                                          eventTypeId
                                          name
                                          eventYear
                                      }
                                      transactionEntity {
                                          transactionId
                                          totalAmount
                                          paymentStatus
                                          createdAt
                                      }
                                  }
                                }
                            }
                          `,
                }),
            });

            const data = await response.json();
            if (response.ok) {
                console.log("Event history data API call:", response, data.data.eventsHistory.events);

                setEventTxnsHistory(data.data.eventsHistory.events);
            } else {
                if (response.status === 403) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || 'OTP expired');
                    //handleLogout(); // Logout user
                } else {
                    if (!response.ok) {
                        const errorData = await response.json();
                        throw new Error(errorData.message || 'Membership fetch failed');
                    }
                }
            }
        } catch (error) {
            console.error("Error fetching Event Txns History :", error);
            //signOut();
            //navigate('/');
        }
    };



    const handleLogout = () => {
        signOut();
        navigate('/');
    };

    const memberProfileFetch = async () => {
        console.log("Token value B", accessToken);
        let response, data;
        try {
            //const response = await fetch('https://membership.cmdfw.org/api/gquery', {
            const response = await fetch(`${API_URL}/gquery`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-cmdfw-jwt-token': `${accessToken}`,
                },
                body: JSON.stringify({
                    query: `
                          query {
                            memberships {
                                balaviharYear
                                balaviharPeriod
                                status
                                totalAmountPaid
                                membershipTypes {
                                    membershipTypeId
                                    name
                                    startDate
                                    endDate
                                    bvPrice
                                    childQuantities
                                }
                                availableSessions {
                                    sessionId
                                    center
                                    sessionName
                                    grades {
                                        gradeId
                                        grade
                                    }
                                }
                                registeredSessions{
                                    bvRegistrationId
                                    regStartDate
                                    regEndDate
                                    status
                                    memberEntity{
                                        firstName
                                        lastName
                                        fullName
                                    }
                                    sessionEntity {
                                        sessionId
                                        center
                                        sessionName
                                    }
                                    gradeEntity{
                                        gradeId
                                        grade
                                    }
                                }
                                currentMembership {
                                    membershipId
                                    startDate
                                    endDate
                                    status
                                    notes
                                    bvYear
                                    createdAt 
                                    createdBy 
                                    membershipTypesEntity{
                                        membershipTypeId
                                        name
                                        startDate
                                        endDate
                                    }
                                    transactionEntity {
                                        transactionId
                                        eventTypesEntity {
                                            eventTypeId
                                            name
                                            eventYear
                                        }
                                        totalAmount
                                        paymentStatus
                                        createdAt 
                                        createdBy 
                                    }
                                }
                            }
                          }
                        `,
                }),
            });

            const data = await response.json();
            if (response.ok) {
                setMemberships(data.data.memberships);
                console.log("Membership data after API call:", data, response);
            } else {
                if (response.status === 403) {
                    const errorData = await response.json();
                    handleLogout(); // Logout user
                    throw new Error(errorData.message || 'OTP expired');
                } else {
                    if (!response.ok) {
                        const errorData = await response.json();
                        throw new Error(errorData.message || 'Membership fetch failed');
                    }
                }
            }
        } catch (error) {
            console.error("Error fetching Membership Profile :", error);
            signOut();
            //navigate('/');
        }
    };


    const checkoutHandler = (e) => {
        e.preventDefault();
        setError(null);
        applyEmergencyContactToAllChildren();
        // Skip payment if total amount is zero
        if (totalAmount > 0) {
            eventData.status = "pending";
        } else {
            eventData.status = "paid";
            setSuccess(true); // Skip payment if total amount is zero
        }
        setPayloadData(eventData);

        //    console.log("transaction before sent to SQS:", (inputFields));
        if (sendToServer()) {
            console.log("checkout true");
            //setCheckout(true);
        } else {
            //setCheckout(false);
            console.log("checkout false");
        }
    };
    async function sendToServer() {
        const maxRetries = 3; // Maximum number of retries
        let attempt = 0;
        let url_link = `${API_URL}/events`;
        console.log("transaction before sent to Database:", eventData, url_link);


        while (attempt < maxRetries) {
            try {
                //const response = await fetch(`${API_URL}/events`, {
                const response = await fetch(url_link, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        "x-cmdfw-jwt-token": `${accessToken}`,
                    },
                    body: JSON.stringify(eventData),
                });
                console.log('API response:', response.data);
                if (response.ok) {
                    setCheckout(true);
                    return true; // Success
                }
                if (response.status === 403) {
                    const errorData = await response.json();
                    handleLogout(); // Logout user
                    throw new Error(errorData.message || 'OTP expired');
                } else {
                    const errorData = await response.json();
                    console.error('API Error:', errorData);
                    setError(errorData.message);
                    return false; // API call failed
                    //throw new Error(errorData.message || 'API call failed');
                }
            } catch (error) {
                console.error(`Attempt ${attempt + 1} failed:`, error);
                attempt++;

                if (attempt >= maxRetries) {
                    console.error('All retry attempts failed.');
                    setCheckout(false);
                    setError("Failed to send data to the server. Please try again later.");
                    return false; // Return false after all retries fail
                }

                console.log(`Retrying API call... (${attempt}/${maxRetries})`);

            }
        }
    }


    function feeSwitchHandler(e) {
        setFeeEnabled(e.target.checked);
        eventData.feeEnabled = e.target.checked;
    }

    function handleBack() {
        setCheckout(false);
    }

    function handleDonation(e) {
        setInputFields({ ...inputFields, [e.target.name]: parseInt(e.target.value) });
        if (e.target.value >= 0) {
            setDonation(parseInt(e.target.value));
        }
    };

    const handleCancel = () => {
        navigate('/EventTypesForm');
        // Add any additional save logic here, such as API calls
    };


    const [success, setSuccess] = useState(false)
    const [checkout, setCheckout] = useState(false)

    // add these computed line-item values before return
    const ticketQtyNum = parseInt(noOfPeople || 0, 10);
    const ticketUnit = parseFloat(ticketPrice || 0);
    const ticketAmount = Number((ticketQtyNum * ticketUnit).toFixed(2));


    const donationAmountNum = Number(parseFloat(donation || 0).toFixed(2));

    const subtotal = Number((ticketAmount + donationAmountNum).toFixed(2));
    const feeAmount = feeEnabled ? Number((subtotal * 0.03).toFixed(2)) : 0;
    const computedTotal = Number((subtotal + feeAmount).toFixed(2));


    return (
        <div>
            <Grid item xs={12} sm={12}>
                <Typography variant="h6" align="center" gutterBottom>
                    {'CMDFW Registration System'}
                </Typography>
            </Grid>

            <form onSubmit={checkoutHandler}>
                <Grid container direction="column" alignItems="center" >
                    {
                        checkout ?
                            success ?
                                <Grid item>
                                    <img src={successIcon} className="Success-icon" alt="logo" />
                                    <Typography variant="h5" align="center" gutterBottom>
                                        {'Thank You for the Registration'}
                                    </Typography>
                                    <Box sx={{ width: '100%', maxWidth: 500 }}>
                                        <Typography variant="body2" align="left" gutterBottom>
                                            You will receive an email confirmation to this address <b> [ {email} ] </b>
                                        </Typography>
                                    </Box>
                                </Grid>
                                :

                                <Grid item>
                                    <PaypalZelle eventData={eventData} setSuccess={setSuccess} payloadData={payloadData} />
                                    <span>
                                        <Button type="submit" variant="contained" sx={{ mt: 3, mb: 2 }} onClick={() => handleBack()}>Back</Button>
                                    </span>
                                </Grid>
                            :
                            <div>
                                <Grid item xs={12} sm={12}>
                                    <Paper elevation={3}>
                                        <Paper style={{ padding: '16px', backgroundColor: '#dfe7e7', color: 'black' }} elevation={3}>
                                            <Grid item>
                                                <Box sx={{ width: '100%', minWidth: 300 }}>
                                                    <Typography variant="body2" align="left" gutterBottom>

                                                        <div>{parse(displayEventType.desc || "")}</div><br />
                                                        <div><br /></div>
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Paper>
                                    </Paper>
                                </Grid>
                                <div><br /></div>
                                <Grid item xs={12} sm={12}>
                                    {
                                        "ACTIVE" === "ACTIVE" ?
                                            ""
                                            :

                                            (
                                                <div><b>Membership expired.</b>
                                                    <div><b>RENEW</b> the membership for the period: <b>{memberships.balaviharPeriod}</b></div>
                                                    <div><br /></div>
                                                    <Grid item xs={12} sm={12}>
                                                        <Paper elevation={3}>
                                                            <Paper style={{ padding: '16px', backgroundColor: '#dfe7e7', color: 'black' }} elevation={3}>
                                                                <Grid item>
                                                                    <Box sx={{ width: '100%', minWidth: 300 }}>
                                                                        <Typography variant="body2" align="left" gutterBottom>

                                                                            <div><b>Your Membership has expired. Please RENEW your membership before registering for Labor Day Retreat. </b></div>

                                                                        </Typography>
                                                                    </Box>
                                                                </Grid>
                                                            </Paper>
                                                        </Paper>
                                                    </Grid>
                                                    <Grid item>
                                                        <Button onClick={handleCancel} variant="contained" sx={{ mt: 3, mb: 2 }}>Cancel</Button>
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography variant="body2" align="center" gutterBottom>
                                                            If you have any questions, please contact us at <a href="mailto:membership@cmdfw.org">membership@cmdfw.org</a>
                                                        </Typography>
                                                    </Grid>

                                                </div>

                                            )
                                    }

                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    {
                                        "ACTIVE" === "ACTIVE" ?
                                            <Grid container alignItems="center" >

                                                <Paper elevation={3}>

                                                    <Box
                                                        sx={{
                                                            p: 2,
                                                            bgcolor: '#f8f9fa',
                                                            borderRadius: 2,
                                                            border: '2px solid transparent',
                                                            transition: 'transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease, bgcolor 180ms ease',
                                                            '&:hover': {
                                                                transform: 'translateY(-4px)',
                                                                boxShadow: 4,
                                                                borderColor: 'primary.main',
                                                                bgcolor: '#fff'
                                                            }
                                                        }}
                                                    >

                                                        <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
                                                            <Typography variant="h7" align="left" gutterBottom>
                                                                <b>BalaVihar Student Information</b>
                                                            </Typography>
                                                        </Paper>
                                                        <div><br /></div>

                                                        <Grid container justifyContent="center" alignItems="center" >
                                                            <Grid item>
                                                                {studentFields.length === 0 && (
                                                                    <FormGroup>
                                                                        <FormControlLabel control={<Switch />} label="Add Balavihar Children" size="small" onChange={peopleSwitchHandler} />
                                                                    </FormGroup>
                                                                )}
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                    <Grid item xs={12} sm={12}>
                                                        <Grid container align="left" >
                                                            {studentFields && studentFields.map((studentFields, index) => (
                                                                <div key={index} align="left">
                                                                    <Grid container spacing={2} >

                                                                        <Grid item xs={12} sm={6}>
                                                                            <FormControl variant="outlined" sx={{ m: 1, minWidth: 240 }} size="normal">
                                                                                <InputLabel id="demo-simple-select-standard-label">Full Name</InputLabel>
                                                                                <Select
                                                                                    required
                                                                                    id="standard"
                                                                                    name="fullName"
                                                                                    fullwidth
                                                                                    value={studentFields.fullName}
                                                                                    onChange={(e) => handleStudentChange(e, index)}
                                                                                    label="fullName"
                                                                                >
                                                                                    {getAvailableChildren(index).map((item, index) =>
                                                                                        <MenuItem key={index} value={item}>{item}</MenuItem>
                                                                                    )}
                                                                                </Select>
                                                                            </FormControl>
                                                                        </Grid>

                                                                        <div><br /></div>
                                                                        <Grid item xs={12} sm={12}>
                                                                            <Paper elevation={3}>
                                                                                <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>

                                                                                    <Typography variant="h7" align="left" gutterBottom style={{ fontWeight: 'bold' }}>
                                                                                        Student Allergy Information
                                                                                    </Typography>
                                                                                </Paper>
                                                                                <div><br /></div>
                                                                                <Typography variant="body1" align="left" gutterBottom>
                                                                                    <Typography><b>Please indicate "Yes" or "No".</b> If "Yes" to any of the questions below, provide detailed information.</Typography>
                                                                                    {/* Beautified allergy information section */}

                                                                                    <Box
                                                                                        sx={{
                                                                                            p: 2,
                                                                                            bgcolor: '#f8f9fa',
                                                                                            borderRadius: 2,
                                                                                            border: '2px solid transparent',
                                                                                            transition: 'transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease, bgcolor 180ms ease',
                                                                                            '&:hover': {
                                                                                                transform: 'translateY(-4px)',
                                                                                                boxShadow: 4,
                                                                                                borderColor: 'primary.main',
                                                                                                bgcolor: '#fff'
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        <Typography variant="body2" sx={{ lineHeight: 1.8, color: '#495057', mb: 2 }}>
                                                                                            <Typography variant="body1">Does your child have <b>food allergies?</b> If so, please list down below:</Typography>

                                                                                        </Typography>

                                                                                        <Typography variant="body2" sx={{ lineHeight: 1.8, color: '#495057', mb: 2 }}>
                                                                                            <ul style={{ marginTop: 12, marginBottom: 12, paddingLeft: 24 }}>
                                                                                                <li>All meals are cooked by food certified volunteers in an industrial kitchen on campus</li>
                                                                                                <li>Meals are vegetarian (no meat or eggs) but do use dairy products and various nuts in our recipes</li>
                                                                                                <li>If allergies or medically required precautions are indicated, we will take special care to make special accommodation</li>
                                                                                                <li>Please be specific to the type, level of sensitivity, and severity of reaction</li>
                                                                                                <li><strong>Allergy Examples:</strong> Nuts (indicate which types), lactose intolerance, soy, gluten, etc.</li>
                                                                                            </ul>
                                                                                        </Typography>

                                                                                        <TextField
                                                                                            required
                                                                                            fullWidth
                                                                                            multiline
                                                                                            color='secondary'
                                                                                            id="allergies"
                                                                                            label="Your answer"
                                                                                            name="foodAllergies"
                                                                                            variant="outlined"
                                                                                            value={studentFields.foodAllergies}
                                                                                            onChange={(e) => handleStudentChange(e, index)}
                                                                                        />
                                                                                    </Box>
                                                                                    <div><br /></div>
                                                                                    {/* Beautified medicinal allergies section */}
                                                                                    <Box
                                                                                        sx={{
                                                                                            p: 2,
                                                                                            bgcolor: '#f8f9fa',
                                                                                            borderRadius: 2,
                                                                                            border: '2px solid transparent',
                                                                                            transition: 'transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease, bgcolor 180ms ease',
                                                                                            '&:hover': {
                                                                                                transform: 'translateY(-4px)',
                                                                                                boxShadow: 4,
                                                                                                borderColor: 'primary.main',
                                                                                                bgcolor: '#fff'
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>Does your child have any medicinal allergies? If so, please list down below.</Typography>

                                                                                        <Typography variant="body2" sx={{ lineHeight: 1.8, color: '#495057', mb: 2 }}>
                                                                                            <ul style={{ marginTop: 12, marginBottom: 12, paddingLeft: 24 }}>
                                                                                                <li>Please be specific to the type, level of sensitivity, and severity of reaction</li>
                                                                                                <li><strong>Examples:</strong>
                                                                                                    <ul style={{ marginTop: 8, marginBottom: 8, paddingLeft: 24 }}>
                                                                                                        <li>Antibiotics: Penicillin and related drugs (e.g., amoxicillin)</li>
                                                                                                        <li>Sulfa drugs (sulfonamides)</li>
                                                                                                        <li>NSAIDs (Nonsteroidal Anti-inflammatory Drugs): Aspirin, ibuprofen (Advil, Motrin), and naproxen (Aleve)</li>
                                                                                                    </ul>
                                                                                                </li>
                                                                                            </ul>
                                                                                        </Typography>

                                                                                        <TextField
                                                                                            required
                                                                                            fullWidth
                                                                                            multiline
                                                                                            color='secondary'
                                                                                            id="medicalAllergies"
                                                                                            label="Your answer"
                                                                                            name="medicalAllergies"
                                                                                            variant="outlined"
                                                                                            value={studentFields.medicalAllergies}
                                                                                            onChange={(e) => handleStudentChange(e, index)}
                                                                                        />
                                                                                    </Box>
                                                                                    <div><br /></div>
                                                                                    {/* Beautified environmental allergies section */}
                                                                                    <Box
                                                                                        sx={{
                                                                                            p: 2,
                                                                                            bgcolor: '#f8f9fa',
                                                                                            borderRadius: 2,
                                                                                            border: '2px solid transparent',
                                                                                            transition: 'transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease, bgcolor 180ms ease',
                                                                                            '&:hover': {
                                                                                                transform: 'translateY(-4px)',
                                                                                                boxShadow: 4,
                                                                                                borderColor: 'primary.main',
                                                                                                bgcolor: '#fff'
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>Does your child have any environmental allergies? If so, please list down below.</Typography>

                                                                                        <Typography variant="body2" sx={{ lineHeight: 1.8, color: '#495057', mb: 2 }}>
                                                                                            <ul style={{ marginTop: 12, marginBottom: 12, paddingLeft: 24 }}>
                                                                                                <li>Please be specific to the type, level of sensitivity, and severity of reaction</li>
                                                                                                <li><strong>Examples:</strong>
                                                                                                    <ul style={{ marginTop: 8, marginBottom: 8, paddingLeft: 24 }}>
                                                                                                        <li>Insect bites (bees, ants, wasps, hornets)</li>
                                                                                                        <li>Pollen and hay fever</li>
                                                                                                        <li>Poison ivy, poison oak, poison sumac</li>
                                                                                                        <li>Pet dander</li>
                                                                                                        <li>Latex</li>
                                                                                                    </ul>
                                                                                                </li>
                                                                                                <li><em>(Anything that does not fall into food or medication allergies)</em></li>
                                                                                            </ul>
                                                                                        </Typography>

                                                                                        <TextField
                                                                                            required
                                                                                            fullWidth
                                                                                            multiline
                                                                                            color='secondary'
                                                                                            id="environmentalAllergies"
                                                                                            label="Your answer"
                                                                                            name="environmentalAllergies"
                                                                                            variant="outlined"
                                                                                            value={studentFields.environmentalAllergies}
                                                                                            onChange={(e) => handleStudentChange(e, index)}
                                                                                        />
                                                                                    </Box>
                                                                                    <div><br /></div>
                                                                                    {/* Beautified prescription medications section */}
                                                                                    <Box
                                                                                        sx={{
                                                                                            p: 2,
                                                                                            bgcolor: '#f8f9fa',
                                                                                            borderRadius: 2,
                                                                                            border: '2px solid transparent',
                                                                                            transition: 'transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease, bgcolor 180ms ease',
                                                                                            '&:hover': {
                                                                                                transform: 'translateY(-4px)',
                                                                                                boxShadow: 4,
                                                                                                borderColor: 'primary.main',
                                                                                                bgcolor: '#fff'
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>Is the participant on any prescribed drugs/medication?</Typography>

                                                                                        <TextField
                                                                                            required
                                                                                            fullWidth
                                                                                            multiline
                                                                                            color='secondary'
                                                                                            id="prescriptionMedications"
                                                                                            label="If Yes, Please explain"
                                                                                            name="prescriptionMedications"
                                                                                            variant="outlined"
                                                                                            value={studentFields.prescriptionMedications}
                                                                                            onChange={(e) => handleStudentChange(e, index)}
                                                                                        />
                                                                                    </Box>
                                                                                    <div><br /></div>
                                                                                    {/* Beautified OTC medications section */}
                                                                                    <Box
                                                                                        sx={{
                                                                                            p: 2,
                                                                                            bgcolor: '#f8f9fa',
                                                                                            borderRadius: 2,
                                                                                            border: '2px solid transparent',
                                                                                            transition: 'transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease, bgcolor 180ms ease',
                                                                                            '&:hover': {
                                                                                                transform: 'translateY(-4px)',
                                                                                                boxShadow: 4,
                                                                                                borderColor: 'primary.main',
                                                                                                bgcolor: '#fff'
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>What medications will be brought to retreat?</Typography>

                                                                                        <Typography variant="body2" sx={{ lineHeight: 1.8, color: '#495057', mb: 2 }}>
                                                                                            <ul style={{ marginTop: 12, marginBottom: 12, paddingLeft: 24 }}>
                                                                                                <li><strong>NOTE:</strong> Any/all medications that are brought to the ashram <strong>MUST</strong> be turned in to the designated adult from the organization during a minor's stay</li>
                                                                                                <li>No student/minor may be allowed to keep any prescription drugs/medication in their possession at any time, except as supervised by designated individual</li>
                                                                                            </ul>
                                                                                        </Typography>

                                                                                        <TextField
                                                                                            required
                                                                                            fullWidth
                                                                                            multiline
                                                                                            color='secondary'
                                                                                            id="otcMedications"
                                                                                            label="Please list all medications"
                                                                                            name="otcMedications"
                                                                                            variant="outlined"
                                                                                            value={studentFields.otcMedications}
                                                                                            onChange={(e) => handleStudentChange(e, index)}
                                                                                        />
                                                                                    </Box>
                                                                                    {/* Beautified special instructions/health circumstances section */}
                                                                                    <Box
                                                                                        sx={{
                                                                                            p: 2,
                                                                                            bgcolor: '#f8f9fa',
                                                                                            borderRadius: 2,
                                                                                            border: '2px solid transparent',
                                                                                            transition: 'transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease, bgcolor 180ms ease',
                                                                                            '&:hover': {
                                                                                                transform: 'translateY(-4px)',
                                                                                                boxShadow: 4,
                                                                                                borderColor: 'primary.main',
                                                                                                bgcolor: '#fff'
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>Please use the following space to explain any special instructions/circumstances the retreat volunteers should be aware of regarding the health of the camper:</Typography>

                                                                                        <Typography variant="body2" sx={{ lineHeight: 1.8, color: '#495057', mb: 2 }}>
                                                                                            <ul style={{ marginTop: 12, marginBottom: 12, paddingLeft: 24 }}>
                                                                                                <li>Please be specific to the type, level of sensitivity, and severity, and general coping mechanism your child uses should ailment be triggered until further help if required</li>
                                                                                                <li><strong>Physical Issues: heart disease, diabetes, respiratory issues, back pain, or digestive disorders</strong>
                                                                                                </li>
                                                                                                <li><strong>Mental Health: Anxiety disorders, Depression, Bipolar disorder, Post-Traumatic Stress Disorder (PTSD), Eating disorders, Disruptive behavior and dissocial disorders.</strong>
                                                                                                </li>
                                                                                            </ul>
                                                                                        </Typography>

                                                                                        <TextField
                                                                                            required
                                                                                            fullWidth
                                                                                            multiline
                                                                                            rows={5}
                                                                                            color='secondary'
                                                                                            id="specialInstructions"
                                                                                            label="Please describe any special health instructions or circumstances"
                                                                                            name="specialInstructions"
                                                                                            variant="outlined"
                                                                                            value={studentFields.specialInstructions}
                                                                                            onChange={(e) => handleStudentChange(e, index)}
                                                                                        />
                                                                                    </Box>

                                                                                </Typography>

                                                                                <div><br /></div>

                                                                            </Paper>
                                                                        </Grid>
                                                                        <div><br /></div>

                                                                        <Grid item xs={12} sm={12}>
                                                                            <div><br /></div>
                                                                            <Paper elevation={3} variant="outlined">
                                                                                {// Display the Add/Delete buttons only if the membership is not active
                                                                                }
                                                                                {"ACTIVE" === "ACTIVE" ?
                                                                                    <b>Add Additional Participant  : </b> :
                                                                                    <b>Add/Delete Additional Participant  : </b>
                                                                                }

                                                                                <IconButton onClick={() => handleRemoveFields(index)}>
                                                                                    <DeleteIcon />
                                                                                </IconButton>

                                                                                <IconButton onClick={() => handleAddFields(index)}>
                                                                                    <PersonAddIcon />
                                                                                </IconButton>

                                                                            </Paper>
                                                                        </Grid>
                                                                    </Grid>
                                                                </div>
                                                            ))}
                                                            {error && (
                                                                <Grid item xs={12}>
                                                                    <Alert severity="error">{error}</Alert>
                                                                </Grid>
                                                            )}
                                                        </Grid>

                                                    </Grid>

                                                    <div><br /></div>
                                                    <Grid item xs={12} sm={12}>
                                                        <Box sx={{ width: '100%' }}>
                                                            <Typography variant="body2" align="left" gutterBottom>
                                                                <b>* We will primarily contact you via email for camp-related information, and by phone in case of emergencies. Please ensure that the email address and phone number listed in your Household Profile are current and regularly monitored.</b>
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                    <div><br /></div>
                                                    {/* Beautified emergency contact information section - Applied to all participants */}
                                                    <Box
                                                        sx={{
                                                            p: 2,
                                                            bgcolor: '#f8f9fa',
                                                            borderRadius: 2,
                                                            border: '2px solid transparent',
                                                            transition: 'transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease, bgcolor 180ms ease',
                                                            '&:hover': {
                                                                transform: 'translateY(-4px)',
                                                                boxShadow: 4,
                                                                borderColor: 'primary.main',
                                                                bgcolor: '#fff'
                                                            }
                                                        }}
                                                    >
                                                        <Paper elevation={3}>
                                                            <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
                                                                <Typography variant="h7" align="left" gutterBottom>
                                                                    <b>Emergency Contact Information</b>
                                                                </Typography>
                                                            </Paper>
                                                        </Paper>

                                                        <div><br /></div>

                                                        <Grid container spacing={2} sx={{ mb: 2 }}>
                                                            <Grid item xs={12} sm={6}>
                                                                <TextField
                                                                    required
                                                                    fullWidth
                                                                    color='secondary'
                                                                    id="emergencyContactFullName"
                                                                    label="Full Name"
                                                                    name="emergencyContactFullName"
                                                                    variant="outlined"
                                                                    value={emergencyContact.emergencyContactFullName}
                                                                    onChange={handleEmergencyContactChange}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                <TextField
                                                                    required
                                                                    fullWidth
                                                                    color='secondary'
                                                                    id="emergencyContactRelationship"
                                                                    label="Relationship to Participant"
                                                                    name="emergencyContactRelationship"
                                                                    placeholder="e.g., Parent, Guardian, Aunt, Uncle, etc."
                                                                    variant="outlined"
                                                                    value={emergencyContact.emergencyContactRelationship}
                                                                    onChange={handleEmergencyContactChange}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                <TextField
                                                                    required
                                                                    fullWidth
                                                                    color='secondary'
                                                                    id="emergencyContactMobile"
                                                                    label="Mobile Number"
                                                                    name="emergencyContactMobile"
                                                                    type="tel"
                                                                    variant="outlined"
                                                                    value={emergencyContact.emergencyContactMobile}
                                                                    onChange={handleEmergencyContactChange}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                <TextField
                                                                    required
                                                                    fullWidth
                                                                    color='secondary'
                                                                    id="emergencyContactEmail"
                                                                    label="Email Address"
                                                                    name="emergencyContactEmail"
                                                                    type="email"
                                                                    variant="outlined"
                                                                    value={emergencyContact.emergencyContactEmail}
                                                                    onChange={handleEmergencyContactChange}
                                                                />
                                                            </Grid>

                                                        </Grid>
                                                    </Box>

                                                    <div><br /></div>
                                                    <Grid container direction="column" align="left">
                                                        <Paper elevation={3}>
                                                            <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>

                                                                <Typography variant="h7" align="left" gutterBottom style={{ fontWeight: 'bold' }}>
                                                                    Medical Information
                                                                </Typography>
                                                            </Paper>
                                                            <div><br /></div>
                                                            <Grid container spacing={4}>

                                                                <Grid item xs={12} sm={6}>
                                                                    <Paper elevation={3}>
                                                                        <TextField
                                                                            fullWidth
                                                                            required
                                                                            id="pcpName"
                                                                            label="Primay Care Physican"
                                                                            name="pcpName"
                                                                            variant="outlined"
                                                                            value={medicalFields.pcpName}
                                                                            onChange={handleMedicalChange}
                                                                        />
                                                                    </Paper>
                                                                </Grid>
                                                                <Grid item xs={12} sm={6}>
                                                                    <Paper elevation={3}>
                                                                        <TextField
                                                                            fullWidth
                                                                            required
                                                                            id="pcpmobile"
                                                                            label="Physican Phone #"
                                                                            name="pcpMobile"
                                                                            variant="outlined"
                                                                            value={medicalFields.pcpMobile}
                                                                            onChange={handleMedicalChange}
                                                                        />
                                                                    </Paper>
                                                                </Grid>
                                                                <Grid item xs={12} sm={12}>
                                                                    <Paper elevation={3}>
                                                                        <TextField
                                                                            fullWidth
                                                                            id="medicalInsurance"
                                                                            label="Medical Insurance"
                                                                            name="medicalInsurance"
                                                                            variant="outlined"
                                                                            value={medicalFields.medicalInsurance}
                                                                            onChange={handleMedicalChange}
                                                                        />
                                                                    </Paper>
                                                                </Grid>
                                                                <Grid item xs={12} sm={6}>
                                                                    <Paper elevation={3}>
                                                                        <TextField
                                                                            fullWidth
                                                                            id="groupNo"
                                                                            label="Group No"
                                                                            name="groupNo"
                                                                            variant="outlined"
                                                                            value={medicalFields.groupNo}
                                                                            onChange={handleMedicalChange}
                                                                        />
                                                                    </Paper>
                                                                </Grid>
                                                                <Grid item xs={12} sm={6}>
                                                                    <Paper elevation={3}>
                                                                        <TextField
                                                                            fullWidth
                                                                            id="idNo"
                                                                            label="ID No (if any)"
                                                                            name="idNo"
                                                                            variant="outlined"
                                                                            value={medicalFields.idNo}
                                                                            onChange={handleMedicalChange}
                                                                        />
                                                                    </Paper>
                                                                </Grid>
                                                                <Grid item xs={12} sm={12}>
                                                                    <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
                                                                        <Typography variant="h7" align="left" gutterBottom>
                                                                            <b>Release and Medical Authorization</b>
                                                                        </Typography>
                                                                    </Paper>
                                                                    <div><br /></div>
                                                                    RELEASE OF LIABILITY - In consideration of Chinmaya Mission granting the above named
                                                                    retreater permission to participate in the labor day retreat activities including being transported to
                                                                    and back from the retreat location, I hereby assume all risks of her/his personal injury (including
                                                                    death) that may result from any retreat activity (including residence hall activities). As
                                                                    parent/guardian/responsible party, I do indemnify, defend and hold harmless, Chinmaya Mission
                                                                    and its officers, Volunteer parents and all participants in the retreat program from and against all
                                                                    liability, including claims and suits at law or in equity, for injury, fatal or otherwise, which may
                                                                    result from any negligence and/or the retreater taking part in activities.
                                                                </Grid>
                                                                <Grid item xs={12} sm={12}>
                                                                    <Paper elevation={3}>
                                                                        <TextField
                                                                            id="medicalConsentSignedBy"
                                                                            required
                                                                            fullWidth
                                                                            label="Signature  (Type your Name) :"
                                                                            name="medicalConsentSignedBy"
                                                                            variant="outlined"
                                                                            value={medicalFields.medicalConsentSignedBy}
                                                                            onChange={handleMedicalChange}
                                                                        />
                                                                    </Paper>
                                                                </Grid>
                                                                <Grid item xs={12} sm={12}>
                                                                    <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
                                                                        <Typography variant="h7" align="left" gutterBottom>
                                                                            <b>Consent For Treatment And/Or First Aid</b>
                                                                        </Typography>
                                                                    </Paper>

                                                                    <div><br /></div>
                                                                    <p>
                                                                        In the event of injury or illness, I hereby
                                                                        give my consent for medical treatment and permission to the assigned retreat doctor or any
                                                                        adult retreat volunteer or any Hospital to supervise on-site first aid for minor injuries, and to a
                                                                        licensed physician to hospitalize and secure proper treatment (including injections, anesthesia,
                                                                        surgery, or other reasonable treatment and necessary procedures) for the retreater.
                                                                    </p>
                                                                    <p>
                                                                        <b>EVERY ATTEMPT WILL BE MADE TO CONTACT YOU, THE
                                                                            PARENT/GUARDIAN/RESPONSIBLE PARTY, PRIOR TO ANY MEDICAL
                                                                            ATTENTION BEYOND MINOR FIRST AID,
                                                                            IS GIVEN. </b>
                                                                    </p>
                                                                    <p>
                                                                        <b>Photo Release:</b> With participation, I give permission for myself/my child to be
                                                                        photographed, and/or videotaped while participating in the above stated
                                                                        camp/retreat for the purposes of publicity, staff training, and/or promotion.
                                                                    </p>
                                                                </Grid>
                                                                <Grid item xs={12} sm={12}>
                                                                    <Paper elevation={3}>
                                                                        <TextField
                                                                            id="treatmentConsentSignedBy"
                                                                            required
                                                                            fullWidth
                                                                            label="Signature (Type Parent/Guardian Name) :"
                                                                            name="treatmentConsentSignedBy"
                                                                            variant="outlined"
                                                                            value={medicalFields.medicalConsentSignedBy}
                                                                            onChange={handleMedicalChange}
                                                                        />
                                                                    </Paper>
                                                                </Grid>
                                                            </Grid>
                                                        </Paper>
                                                    </Grid>
                                                    <div><br /></div>
                                                    <RetreatRulesComp eventData={eventData} />
                                                    <div><br /></div>
                                                    <Paper elevation={3}>
                                                        <Grid item xs={12} sm={12}>
                                                            <Paper elevation={3}>
                                                                <TextField
                                                                    id="medicalConsentSignedBy"
                                                                    required
                                                                    fullWidth
                                                                    label="Signature  (Type Parent/Guardian Name) :"
                                                                    name="treatmentConsentSignedBy"
                                                                    variant="outlined"
                                                                    value={medicalFields.treatmentConsentSignedBy}
                                                                    onChange={handleMedicalChange}
                                                                />
                                                            </Paper>
                                                        </Grid>
                                                    </Paper>
                                                    <div><br /></div>

                                                </Paper>
                                            </Grid>
                                            : ""}

                                </Grid>

                                {
                                    "ACTIVE" === "ACTIVE" ? (
                                        <Grid item xs={12} sm={12}>
                                            <div><br /></div>
                                            <Paper elevation={3}>
                                                <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
                                                    <Typography variant="h7" align="left" gutterBottom>
                                                        <b>Payment Information</b>
                                                    </Typography>
                                                </Paper>
                                                <div><br /></div>

                                                <div><br /></div>
                                                <Grid container direction="row" spacing={2} >
                                                    <Grid item xs={12} sm={6}>
                                                        <TextField
                                                            fullWidth
                                                            number
                                                            id="donation"
                                                            label="Additional Donation ($)"
                                                            type="number"
                                                            name="donation"
                                                            variant="standard"
                                                            value={donation}
                                                            onChange={handleDonation}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={12}>
                                                        <FormGroup>
                                                            <FormControlLabel control={<Checkbox checked={feeEnabled} />} label="Add 3% to cover for CC fees"
                                                                value={feeEnabled} size="small" onChange={feeSwitchHandler} />
                                                        </FormGroup>
                                                    </Grid>

                                                    {/* prettier payment breakdown table */}
                                                    <Grid item xs={12} sm={12} sx={{ mt: 1 }}>
                                                        {/* Floating total amount box styled like payment info */}
                                                        <Box
                                                            sx={{
                                                                width: '100%',
                                                                borderRadius: 2,
                                                                bgcolor: 'background.paper',
                                                                transition: 'transform 200ms ease, box-shadow 200ms ease, border-color 200ms ease',
                                                                border: '2px solid transparent',
                                                                '&:hover': {
                                                                    transform: 'translateY(-6px)',
                                                                    borderColor: 'primary.main',
                                                                    boxShadow: 6
                                                                },
                                                                p: 1.25
                                                            }}
                                                        >
                                                            {/* small header to match Payment Information styling */}
                                                            <Paper elevation={0} sx={{ bgcolor: '#673ab7', color: 'white', px: 1.5, py: 0.75, borderRadius: 1 }}>
                                                                <Typography variant="subtitle2"><b>Payment Summary</b></Typography>
                                                            </Paper>
                                                            <TableContainer component={Paper} variant="outlined" sx={{ overflow: 'hidden' }}>
                                                                <Table size="small" aria-label="payment breakdown">
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell
                                                                                sx={{
                                                                                    bgcolor: '#f3f4f6',
                                                                                    color: 'text.primary',
                                                                                    fontWeight: 800,
                                                                                    textTransform: 'uppercase',
                                                                                    letterSpacing: '0.08em',
                                                                                    borderBottom: '2px solid rgba(0,0,0,0.08)'
                                                                                }}
                                                                            >
                                                                                Item
                                                                            </TableCell>
                                                                            <TableCell
                                                                                align="right"
                                                                                sx={{
                                                                                    bgcolor: '#f3f4f6',
                                                                                    color: 'text.primary',
                                                                                    fontWeight: 800,
                                                                                    textTransform: 'uppercase',
                                                                                    letterSpacing: '0.08em',
                                                                                    borderBottom: '2px solid rgba(0,0,0,0.08)'
                                                                                }}
                                                                            >
                                                                                Unit
                                                                            </TableCell>
                                                                            <TableCell
                                                                                align="right"
                                                                                sx={{
                                                                                    bgcolor: '#f3f4f6',
                                                                                    color: 'text.primary',
                                                                                    fontWeight: 800,
                                                                                    textTransform: 'uppercase',
                                                                                    letterSpacing: '0.08em',
                                                                                    borderBottom: '2px solid rgba(0,0,0,0.08)'
                                                                                }}
                                                                            >
                                                                                Qty
                                                                            </TableCell>
                                                                            <TableCell
                                                                                align="right"
                                                                                sx={{
                                                                                    bgcolor: '#f3f4f6',
                                                                                    color: 'text.primary',
                                                                                    fontWeight: 800,
                                                                                    textTransform: 'uppercase',
                                                                                    letterSpacing: '0.08em',
                                                                                    borderBottom: '2px solid rgba(0,0,0,0.08)'
                                                                                }}
                                                                            >
                                                                                Amount
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {ticketQtyNum > 0 && (
                                                                            <TableRow>
                                                                                <TableCell>All TX High School Retreat</TableCell>
                                                                                <TableCell align="right">${ticketUnit.toFixed(2)}</TableCell>
                                                                                <TableCell align="right">{ticketQtyNum}</TableCell>
                                                                                <TableCell align="right">${ticketAmount.toFixed(2)}</TableCell>
                                                                            </TableRow>
                                                                        )}

                                                                        {donationAmountNum > 0 && (
                                                                            <TableRow>
                                                                                <TableCell>Additional Donation</TableCell>
                                                                                <TableCell align="right">—</TableCell>
                                                                                <TableCell align="right">1</TableCell>
                                                                                <TableCell align="right">${donationAmountNum.toFixed(2)}</TableCell>
                                                                            </TableRow>
                                                                        )}
                                                                        {feeAmount > 0 && (
                                                                            <TableRow>
                                                                                <TableCell>Credit Card Fee (3%)</TableCell>
                                                                                <TableCell align="right">—</TableCell>
                                                                                <TableCell align="right">1</TableCell>
                                                                                <TableCell align="right">${feeAmount.toFixed(2)}</TableCell>
                                                                            </TableRow>
                                                                        )}


                                                                        <TableRow>
                                                                            <TableCell colSpan={3} align="right"><Typography sx={{ fontWeight: 900, fontSize: 16 }}>Total</Typography></TableCell>
                                                                            <TableCell align="right"><Typography sx={{ fontWeight: 900, fontSize: 16 }}>${computedTotal.toFixed(2)}</Typography></TableCell>
                                                                        </TableRow>
                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer>

                                                            <Grid item xs={12}>
                                                                <Box sx={{
                                                                    p: 1,
                                                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                                    borderRadius: 4,
                                                                    color: 'white',
                                                                    textAlign: 'center',
                                                                    border: '2px solid rgba(255, 255, 255, 0.2)'
                                                                }}>
                                                                    <Typography variant="h5" sx={{ fontWeight: 700 }}>
                                                                        Total Amount: ${totalAmount}
                                                                    </Typography>
                                                                </Box>
                                                            </Grid>




                                                        </Box>
                                                    </Grid>

                                                </Grid>
                                            </Paper>

                                            <div><br /></div>
                                            <Grid container direction="row" spacing={5}>
                                                <Grid item>
                                                    <Typography variant="body2" align="center" gutterBottom>
                                                        <b>Waiver Statement (Please read and agree to the waiver statement before you proceed) :</b> <a href="https://membership.cmdfw.org/docs/cmdfw-waiver.pdf" target="_blank" rel="noopener noreferrer"> Open PDF </a>
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container direction="row" spacing={5}>
                                                <Grid item>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={rulesAccepted}
                                                                onChange={(e) => setRulesAccepted(e.target.checked)}
                                                                name="rulesAccepted"
                                                                color="primary"
                                                            />
                                                        }
                                                        label="I accept the rules and policies"
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid container direction="row" spacing={2}>

                                                <Grid item>
                                                    <Button onClick={handleCancel} variant="contained" sx={{ mt: 3, mb: 2 }}>Cancel</Button>
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title={!rulesAccepted ? "Please accept the rules and policies" : ""}>
                                                        <span>
                                                            <Button type="submit" variant="contained" sx={{ mt: 3, mb: 2 }} disabled={!rulesAccepted}>Checkout</Button>
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                                {error && (
                                                    <Grid item xs={12}>
                                                        <Alert severity="error">{error}</Alert>
                                                    </Grid>
                                                )}
                                            </Grid>
                                            <Grid container direction="row" spacing={5}>
                                                <Grid item>
                                                    <Typography variant="body2" align="center" gutterBottom>
                                                        If you have any questions, please contact us at <a href="mailto:membership@cmdfw.org">membership@cmdfw.org</a>
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>) : ""}
                            </div>
                    }
                </Grid>
            </form>
        </div >
    );
}